import { gql } from '@apollo/client'

const SEARCH_INSURANCE_COMPANIES = gql`
  query SEARCH_INSURANCE_COMPANIES($searchTerm: String!) {
    searchInsuranceCompanies(searchTerm: $searchTerm) {
      id
      name
      number
      taxNumber
      taxPercent
      insurancePercentage
      insuranceLimit
      insuranceUnlimited
      approvalRequired
      insuranceStartMonth
      forcePolicySelect
      nphiesCode
      nphiesInsuranceCompanyId
      tpaNphiesCode
      priceList {
        id
        name
      }
    }
  }
`

export default SEARCH_INSURANCE_COMPANIES
